import { LoadingSpinner } from '../../ui/LoadingSpinner'
import { T } from './copy'
import { ThresholdCanvas } from './primitives'

interface AuthenticatingScreenProps {
  testId?: string
}

/**
 * Screen 2 — the transient authenticating threshold shown while MSAL hands the
 * user to Microsoft and back. The status region is announced via aria-live so
 * assistive tech hears the transition.
 *
 * @param testId - data-testid applied to the stage root. Defaults to 'auth-loading'.
 * @returns The authenticating threshold screen.
 */
export function AuthenticatingScreen({ testId = 'auth-loading' }: AuthenticatingScreenProps) {
  return (
    <ThresholdCanvas glow={false} testId={testId}>
      <div
        role="status"
        aria-live="polite"
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 28,
          textAlign: 'center',
        }}
      >
        <div className="fade" style={{ animationDelay: '80ms' }}>
          <LoadingSpinner size="lg" />
        </div>
        <p
          className="fade"
          style={{
            ...T.headline,
            fontSize: 'clamp(1.5rem, 3vw, 2.25rem)',
            color: 'var(--paper)',
            animationDelay: '160ms',
          }}
        >
          Authenticating<span aria-hidden="true">…</span>
        </p>
        <p
          className="fade"
          style={{
            ...T.body,
            maxWidth: '30ch',
            textAlign: 'center',
            margin: '0 auto',
            color: 'var(--muted)',
            animationDelay: '260ms',
          }}
        >
          Handing you to Microsoft, then back again.
        </p>
      </div>
    </ThresholdCanvas>
  )
}
